import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TagRegularDiagonal from './tag-regular-diagonal-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TagRegularDiagonal {...validProps} />;
}

SvgComponent.iconName = 'tagRegularDiagonal';

export const TagRegularDiagonalIcon = svgIconWrapper(SvgComponent);
